<template>
  <v-container>
    <v-row>
      <edit-tag-modal
          :editing="showTagDialog"
          :tag-object="editTag"
          @dialog-clicked="showTagDialog = false"
      />

      <edit-category-modal
          :editing="showCategEdit"
          :category-object="editCateg"
          @dialog-clicked="showCategEdit = false"
      />

    </v-row>
    <v-row align="center">
      <v-col cols="9">
        <v-autocomplete
            v-model="selectedCategories"
            :items="categoryOptions"
            :search-input.sync="searchInput"
            chips
            class="mt-4"
            item-text="name"
            item-value="id"
            label="Categories"
            multiple
            small-chips
            @change="searchInput=''"
        >

          <template v-slot:selection="data">
            <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeCategoryFromList(data.item)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
              <v-list-item-subtitle v-if="!data.item.is_active">
                Inactive
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon small @click.stop="openCategoryFormById(data.item.id)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </v-list-item-action>
          </template>


        </v-autocomplete>
        <v-checkbox
            v-model="showInactiveCategories"
            class="mt-0"
            dense
            hide-details
            label="Show inactive categories"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-select
            v-model="filter.is_active"
            :items="active"
            item-text="text"
            item-value="value"
            label="Is Active"
        ></v-select>
      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
            :custom-filter="filterTagsByName"
            :footer-props="{
                    'items-per-page-options': [ 10, 25, 50, -1]
                }"
            :headers="headers"
            :items="displayTags"
            :search="search"
            class="elevation-1"
            item-key="tag"
            loading-text="Loading... Please wait"
        >

          <template v-slot:item.is_active="{ item }">
            {{ item.is_active ? 'Yes' : 'No' }}
          </template>

          <template v-slot:item.name="{ item }">
            <button class="text-decoration-underline text-primary" @click="openTagForm(item)"> {{
                item.name
              }}
            </button>
          </template>

          <template v-slot:item.category="{ item }">
            <button class="text-decoration-underline text-primary" @click="openCategoryForm(item)">
              {{ item.category.name }}
            </button>
          </template>

          <template v-slot:top>
            <v-text-field
                v-model="search"
                class="mx-4"
                label="Search by Tag Name"
            ></v-text-field>
          </template>
        </v-data-table>

      </v-col>
    </v-row>

    <v-row class="float-right">
      <v-col>
        <v-btn class="mr-2" color="success" @click="newCategory">New Category</v-btn>

        <v-btn color="primary" @click="newTag">New Tag</v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import EditTagModal from '@/components/forms/EditTagModal.vue'
import EditCategoryModal from "@/components/forms/EditCategoryModal.vue";

import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'

export default {
  name: 'TagManagement',
  components: {
    EditTagModal,
    EditCategoryModal
  },
  data() {
    return {
      selectedCategories: [],
      showInactiveCategories: false,
      allCategoriesList: [],
      searchInput: null,
      filteredTags: [],
      search: '',
      active: [
        {
          text: "Active",
          value: true
        },
        {
          text: "Not Active",
          value: false
        }
      ],
      showTagDialog: false,
      editTag: {},
      showCategEdit: false,
      editCateg:{},
      filter: {
        clicked: true,
        label: 'Select Category',
        is_active: true
      },
    }
  },
  mounted() {

    this.filteredTags = this.tags;
  },
  watch: {
    showInactiveCategories(show) {
      if (show) {
        this.refreshAllCategories()
      } else {
        // Drop selected categories that are no longer in the dropdown —
        // otherwise they keep filtering the table with no visible chip.
        this.selectedCategories = this.selectedCategories.filter(
            id => this.categories.some(cat => cat.id === id)
        )
      }
    },
    showCategEdit(open) {
      if (!open && this.showInactiveCategories) this.refreshAllCategories()
    }
  },
  computed: {
    ...mapState({
      tags: state => state.tags.tags,
      categories: state => state.categories.categories
    }),
    ...mapGetters(['getCategoryNames']),
    headers() {
      return [
        {
          text: 'Category',
          value: 'category',
          sortable: true,
          sort: (a, b) => {
            return a.name.localeCompare(b.name);
          }
        },
        {
          text: 'Tag',
          value: 'name',
          sortable: true
        },
        {
          text: 'Is Active',
          value: 'is_active',
          sortable: true
        },
      ]
    },
    displayTags(){
      return this.tags.filter(tag => this.filterTags(tag));
    },
    categoryOptions() {
      return this.showInactiveCategories ? this.allCategoriesList : this.categories
    }


  },
  methods: {
    ...mapMutations(['setTags']),
    ...mapActions(['getAllCategoriesList']),
    async refreshAllCategories() {
      this.allCategoriesList = await this.getAllCategoriesList()
    },
    newCategory() {
      this.editCateg =  {
        id: null,
        name: '',
        is_active: true
      }
      this.showCategEdit = true
    },
    removeCategoryFromList(e) {
      this.selectedCategories = this.selectedCategories.filter(cat => cat !== e.id)
    },
    newTag() {
      this.editTag = {
        id: null,
        name: '',
        is_active: true,
        category: {
          value: '',
          choices: this.categories
        }
      }
      this.showTagDialog = true
    },
    applyFilters() {
      console.log('Applying filters');
      this.filteredTags = this.tags.filter(tag => this.filterTags(tag));
    },
    sortActive() {
      console.log('sorting');
    },
    filterTags(tag) {
      if (this.selectedCategories.length > 0) {

        return this.selectedCategories.includes(tag.category.id) && tag.is_active === this.filter.is_active
      } else {
        return tag.is_active === this.filter.is_active
      }
    },
    filterTagsByName(value, search, item) {
      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
    openTagForm(item) {
      this.editTag = {
        id: item.id,
        name: item.name,
        category:{
          value: item.category.id,
          choices: this.categories
        },
        is_active: item.is_active
      }

      this.showTagDialog = true
    },
    openCategoryForm(item) {
      // Prefer the store category (it carries number_of_tags); fall back to
      // the row's nested category so inactive categories stay reachable.
      const category = this.categories.find(cat => cat.id === item.category.id) || item.category
      this.editCateg = {
        id: category.id,
        name: category.name,
        is_active: category.is_active,
        number_of_tags: category.number_of_tags
      }

      this.showCategEdit = true
    },
    openCategoryFormById(categoryId) {
      const category = this.categoryOptions.find(cat => cat.id === categoryId) ||
          this.categories.find(cat => cat.id === categoryId)
      if (!category) return
      this.editCateg = {
        id: category.id,
        name: category.name,
        is_active: category.is_active,
        number_of_tags: category.number_of_tags
      }

      this.showCategEdit = true
    },
  }
}
</script>

<style>
</style>
